import { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { getEndpoint, getMUICache, getUrl, setCmsSeoData, fetchAnchorValue } from '../../../common/utils';
import './BreadCrumbsThree.css'
import bcrypt from 'bcryptjs-react';

BreadCrumbsThree.version = 1000;

BreadCrumbsThree.lang = 'en';
BreadCrumbsThree.langs = [
    'en'
];
BreadCrumbsThree.setLang = (lang: any) => {
    BreadCrumbsThree.lang = lang;
}

Object.defineProperty(BreadCrumbsThree, 'name', {
    writable: true,
    value: 'BreadCrumbsThree'
});

export function BreadCrumbsThree(props: any) {
    const [breadCrumbsData, setbreadCrumbsData] = useState<any>({});
    const { categoryName, seperator, anchorLinksValue } = props;
    const [baseCatogeryName, setbaseCatogeryName] = useState<any>("");
    const [name, setName] = useState('');
    const cache = getMUICache();


    let {includeTitle} = props;
    if(typeof includeTitle === 'undefined') {includeTitle = true;}

    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }

    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    useEffect(() => {
        if (breadCrumbsData && Object.keys(breadCrumbsData).length > 0 && breadCrumbsData.items.length > 0) {
            let updatedData = { ...breadCrumbsData }
            if (updatedData.items && updatedData.items[updatedData.items.length - 1] && updatedData.items[0].hl != categoryName) {
                updatedData.items[updatedData.items.length - 1].hl = categoryName != "" ? categoryName : baseCatogeryName;
            }
            setbreadCrumbsData(updatedData);
        }

    }, [categoryName]);

    if (endpoint.isSSR && endpoint.SSRDataObj && endpoint.SSRDataObj.items && breadCrumbsData && Object.keys(breadCrumbsData).length === 0 && endpoint.SSRDataObj.items.length > 0) {
        if (endpoint.SSRDataObj.items && endpoint.SSRDataObj.items[endpoint.SSRDataObj.items.length - 1]) {
            setbaseCatogeryName(endpoint.SSRDataObj.items[endpoint.SSRDataObj.items.length - 1].hl)
        }
        if (categoryName != "" && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items[endpoint.SSRDataObj.items.length - 1] && endpoint.SSRDataObj.items[0].hl != categoryName) {
            endpoint.SSRDataObj.items[endpoint.SSRDataObj.items.length - 1].hl = categoryName;
        }
        setbreadCrumbsData(endpoint.SSRDataObj);
        setCmsSeoData(props, JSON.parse(JSON.stringify(endpoint.SSRDataObj.items)), "BreadCrumbs");
    }

    const fetchComponentData = () => {
        const breadCrumbsUrl = getUrl(props, 1, false, "MAIN", true);

        let headerString = '?' + breadCrumbsUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(breadCrumbsUrl, { headers: headers })
            .then((response) => response.json())
            .then((data) => {
                if (data.items && data.items[data.items.length - 1]) {
                    setbaseCatogeryName(data.items[data.items.length - 1].hl)
                }
                if (categoryName != "" && data.items && data.items[data.items.length - 1]) {
                    data.items[data.items.length - 1].hl = categoryName;
                }
                setbreadCrumbsData(data)
                if(data && data.items) setCmsSeoData(props, JSON.parse(JSON.stringify(data.items)), "BreadCrumbs");
            }
            )
    }

    const getData = () => {
            // Helper function to strip HTML tags
        const stripHtmlTags = (input: string): string => {
            return input.replace(/<[^>]*>/g, ''); // This removes HTML tags
        };
        if (REQUEST_URL != null && (REQUEST_URL.includes('/topics/') || REQUEST_URL.includes('/tags/') || REQUEST_URL.includes('/author/'))
            || (props.PAGE_TYPE !== undefined && props.PAGE_TYPE === 'ErrorPage')) {
            if (name === '') {
                if (REQUEST_URL.includes('/topics/')) {
                    const topicName = REQUEST_URL.split("/topics/")[1].split("?")[0];
                    setName(decodeURIComponent(topicName));
                } else if (REQUEST_URL.includes('/tags/')) {
                    const parts = REQUEST_URL.split("/");
                    const encodedText = parts[parts.length - 1];
                    const decodedText = decodeURIComponent(encodedText);
                    const tagName = decodedText.split("?")[0];
                    setName(tagName);
                } else if (props.PAGE_TYPE === 'ErrorPage') {
                    setName('Page Not Found')
                } else {
                    fetchData()
                }
            }

            return [
                <Link
                    key='ddbb_999'
                    underline="hover"
                    className={""}
                    target={fetchAnchorValue(anchorLinksValue, "/")}
                    rel="noopener"
                    href={"/"}
                    style={{ color: props.TextColor }}

                >
                    {(categoryName !== undefined && categoryName !== "") ? categoryName : 'Home'}
                </Link>
                ,
                (name && includeTitle) ? (
                    <span key='bbb2span_999' className='activepage'>
                        {/* {decodeURIComponent(name)} */}
                        {stripHtmlTags(decodeURIComponent(name))}
                    </span>
                ) : null,
            ]
        }

        // const maxLengths = {
        //     oneBreadcrumb: 54,
        //     oneBreadcrumbOneTitle: 26,
        //     twoBreadcrumbsOneTitle: 29,
        //     threeBreadcrumbsOneTitle: 8,
        // };

        //const breadcrumbsCount = breadCrumbsData.items && breadCrumbsData.items.length || 0;
        const hasTitle = breadCrumbsData.title && breadCrumbsData.title !== "";

        // const getMaxStringLength = () => {
        //     if (breadcrumbsCount === 1 && !hasTitle) {
        //         return maxLengths.oneBreadcrumb;
        //     } else if (breadcrumbsCount === 1 && hasTitle) {
        //         return maxLengths.oneBreadcrumbOneTitle;
        //     } else if (breadcrumbsCount === 2 && hasTitle) {
        //         return maxLengths.twoBreadcrumbsOneTitle;
        //     } else if (breadcrumbsCount === 3 && hasTitle) {
        //         return maxLengths.threeBreadcrumbsOneTitle;
        //     } else {
        //         return Infinity; // Default to no maximum length
        //     }
        // };

        const truncateString = (inputString: any, maxLength: any) => {
            return inputString.length <= maxLength
                ? inputString
                : inputString.substring(0, maxLength) + '...';
        };

        let data = [...breadCrumbsData.items];

        return [
            data.reverse().map((item: any, index: any) => (
                <Link
                    underline="hover"
                    key={`bb${index}_${index}`}
                    className={""}
                    target={fetchAnchorValue(anchorLinksValue, item.wu === "" ? "/" : item.wu)}
                    rel="noopener"
                    href={item.wu === "" ? "/" : item.wu}
                    style={{ color: props.TextColor }}
                >
                    {truncateString(item.hl, 30)}
                </Link>
            )),
            (hasTitle && includeTitle) ? (
                <span key='bbbspan_999' className='activepage'>
                    {/* {truncateString(breadCrumbsData.title, 60)} */}
                    {stripHtmlTags(truncateString(breadCrumbsData.title, 60))}
                </span>
            ) : null,
        ];
    };

    async function fetchData() {
        let cdsDomain: any = '';
        if (typeof props.CONSTANTS.CDS_API !== "undefined") {
            cdsDomain = props.CONSTANTS.CDS_API;
        } else {
            cdsDomain = props.CONSTANTS.API_URL.CDS_API;
        }
        const parts = REQUEST_URL.split('/');
        const id = parts[parts.length - 1].replace('.html', '').split('?')[0];
        const url = `${cdsDomain}/cds-feed-ext/author/details/${id}?hostId=${endpoint.queryParams.hostId}`;

        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        let res = await fetch(url, { headers: headers });
        let data = await res.json();
        if (data.response && data.response.author) {
            setName(data.response.author[0].name);
        } else {
            setName('Author');
        }
    }

    return (
        <div className='commoncontainer'>
            <CacheProvider value={cache}>
                <Grid>
                    <div className='breadcrumbwrapper'>
                        <Breadcrumbs aria-label="breadcrumb" separator={seperator} >
                            {props.PAGE_TYPE !== undefined && props.PAGE_TYPE === 'ErrorPage' && breadCrumbsData && Object.keys(breadCrumbsData).length == 0 && getData()}
                            {breadCrumbsData && Object.keys(breadCrumbsData).length > 0 && getData()}
                            {REQUEST_URL != null && (REQUEST_URL.includes('/topics/') || REQUEST_URL.includes('/tags/') || REQUEST_URL.includes('/author/')) && breadCrumbsData && Object.keys(breadCrumbsData).length == 0 && getData()}
                        </Breadcrumbs>
                    </div>
                </Grid>
            </CacheProvider>
        </div>
    )

}
